import { useChatProfileShallowSelector } from 'components/AskDelaChat/ChatProfileStore'
import { useMemo } from 'react'

/**
 * A custom hook to determine if actions should be disabled based on the user's role.
 * @returns {boolean} A boolean indicating whether actions should be disabled based on the user's role.
 */
export function useShouldDisableActions(): boolean {
    const role = useChatProfileShallowSelector((state) => state.chatUser?.role)
    return useMemo(() => role === 'Reviewer', [role])
}
